import { Token } from 'domain/models';

export const isValid = (token: Token): [boolean, number] => {
	const msDate = new Date(Date.now() + token.expires_in * 1000).valueOf();

	const msNow = Date.now();

	const remaining = msDate - msNow;

	return [remaining > 0, remaining];
};
